<template>
  <!-- 商品列表组件 -->
  <div class="page-food">
    <!-- 两个一行 -->
    <div class="food-list-tow" v-if="type == 0">
      <van-cell
        class="food-list-item"
        v-for="(item, index) in list"
        :key="index"
      >
        <!-- 套装 -->
        <div v-if="item.composeStatus == 1 || item.composeStatus == 2">
          <div class="item-base-left">
            <img
              :src="item.composeDataVO.main.filename || localImg"
              alt=""
              @click="lookImg(item.composeDataVO.main.osslinks)"
            />
            <div class="list-product-triangle"></div>
            <div class="list-product-status" v-if="item.composeStatus == 1">
              套
            </div>
            <div class="list-product-status" v-if="item.composeStatus == 2">
              临
            </div>
            <div class="list-product-sign" v-if="!isTouris">
              每{{
                item.composeStatus == 1 ? "套" : item.composeDataVO.main.dwName
              }}省{{ item.composeDataVO.discountPrice }}元
            </div>
            <div
              class="show-over-time"
              v-if="item.composeDataVO.main.sm !== ''"
            >
              <span>保质期{{ getTime(item) }}</span>
            </div>
          </div>
          <div
            class="item-product-name line-clamp-2"
            v-if="item.composeStatus == 1"
          >
            {{ item.composeDataVO.title }}
          </div>
          <div class="item-product-name line-clamp-2" v-else>
            {{ item.composeDataVO.main.pm }}
          </div>
          <div class="item-specfollow">
            <div class="item-product-spec">
              条码:{{ item.composeDataVO.main.tm }}
            </div>
          </div>
          <div class="item-specfollow">
            <div class="item-product-spec">
              编号:{{ item.composeDataVO.main.cpbh }}
            </div>
          </div>
          <div v-if="isTouris" class="item-product-hide">会员可见</div>
          <div class="product-add-reduce flex-h" style="height: 24px" v-else>
            <div style="font-size: 12px" v-if="item.composeStatus == 1">
              <span class="item-list-price">¥{{ item.composeDataVO.dj }}</span
              >/套
            </div>
            <div style="font-size: 12px" v-if="item.composeStatus == 2">
              <span class="item-list-price">¥{{ item.composeDataVO.dj }}</span
              >/{{ item.composeDataVO.main.dwName }}
            </div>
            <div
              class="item-click-detail"
              style="justify-content: flex-end"
              @click="enterDetail(item.composeDataVO, index)"
              v-if="item.composeDataVO.tmpSellOver == 0"
            >
              <div
                class="item-rigrht-buy"
                :class="{ showOpacity: item.composeDataVO.dj == 0 }"
                v-if="
                  item.composeDataVO.sl === 0 &&
                  (!item.composeDataVO.numProduct ||
                    item.composeDataVO.numProduct[0].zsl == 0)
                "
              >
                展开购买
              </div>
              <div class="item-rigrht-buy" v-else>
                共{{ item.composeDataVO.sl }}
                <span v-if="item.composeStatus == 1">套</span>
                <span v-if="item.composeStatus == 2">{{
                  item.composeDataVO.main.dwName
                }}</span>
              </div>
            </div>
            <div
              class="item-click-detail"
              style="justify-content: flex-end"
              v-else
            >
              <div class="item-rigrht-buy showOpacity">已售罄</div>
            </div>
          </div>

          <div class="list-item-tips" v-if="!isTouris">
            <span>特</span>
            <span
              >原价{{ item.composeDataVO.bzsj }},可省{{
                item.composeDataVO.discountPrice
              }}元</span
            >
          </div>
          <!-- <div class="list-item-tips" v-if="item.composeDataVO.main.sm">
            <span>保</span>
            <span>保质期{{ item.composeDataVO.main.sm }}</span>
          </div> -->
        </div>
        <!-- 常规产品 -->
        <div v-else>
          <div class="item-base-left">
            <img
              :src="item.filePath || localImg"
              alt=""
              @click="lookImg(item.osslinks)"
            />
            <!-- <div class="item-has-product" v-if="item.kcst == 1">有货</div> -->
            <div class="item-no-product" v-if="item.kcst < 1">售罄</div>
            <div class="list-product-sign" v-if="!isTouris && item.cxFileData">
              <span v-if="item.cxFileData.promotiontype == '赠送促销'"
                >有赠品</span
              >
              <span v-else>每{{
                    item.cxFileData.djdw == 3
                      ? item.dw1
                      : item.cxFileData.djdw == 2
                      ? item.dw2
                      : item.dw
                  }}省{{ getDiscount(item) }}元</span>
            </div>
            <div
              class="item-no-coupon"
              v-if="
                item.productCoupon &&
                item.productCoupon == 1 &&
                item.takeCouponCode &&
                item.takeCouponCode == 0
              "
              @click="takeConpou(item)"
            >
              领券
            </div>
            <div
              class="item-has-coupon"
              v-if="
                item.productCoupon &&
                item.productCoupon == 1 &&
                item.takeCouponCode &&
                item.takeCouponCode == 1
              "
            >
              已领
            </div>
          </div>
          <div
            class="item-product-name line-clamp-2"
            @click="enterDetail(item, index)"
          >
            {{ item.pm }}
          </div>
          <div class="item-specfollow">
            <div class="item-product-spec">条码:{{ item.tm }}</div>
            <!-- 设置气泡框 -->
            <div class="number-Bubble-pop" v-show="item.showPop > 0">
              <div class="tag">
                <div @click.stop="item.showKey = true">
                  数量:{{
                    item.showPop == 1
                      ? item.sl
                      : item.showPop == 2
                      ? item.sl1
                      : item.sl2
                  }}{{
                    item.showPop == 1
                      ? item.dw
                      : item.showPop == 2
                      ? item.dw1
                      : item.dw2
                  }}
                </div>
                <div class="pop-shu">|</div>
                <div @click.stop="popReduce(item)">
                  <van-icon name="minus" class="pop-minus" />
                </div>
              </div>
              <van-number-keyboard
                :title="'当前输入值:' + keyNum"
                @input="onInput"
                theme="custom"
                close-button-text="完成"
                :show="item.showKey"
                @blur="onBlur(item)"
                @delete="onDelete"
              />
            </div>
            <!-- 设置价格气泡框 -->
            <div class="price-Bubble-pop" v-show="item.showPrice > 0">
              <div class="tag">
                {{ getPrice(item, item.showPrice) }}/{{
                  item.showPrice == 1
                    ? item.dw
                    : item.showPrice == 2
                    ? item.dw1
                    : item.dw2
                }}
              </div>
              <van-number-keyboard
                :title="'当前输入值:' + keyPrice"
                @input="onInput1"
                theme="custom"
                extra-key="."
                close-button-text="完成"
                :show="item.priceKey"
                @blur="onBlur1(item)"
                @delete="onDelete1"
              />
            </div>
            <!-- <div class="item-product-follow" v-if="item.gzcp == 0">关注</div>
          <div class="item-product-follow" v-else>已关注</div> -->
          </div>
          <div style="color: #999; margin-top: 6px; font-size: 12px">
            编号:{{ item.cpbh }}
          </div>
          <!-- 游客登陆 -->
          <div class="item-product-hide" v-if="isTouris">会员可见</div>
          <!-- 正常登陆 -->
          <div v-else>
            <!-- 产品购买列表 -->
            <div
              class="item-buy-unit"
              v-if="
                (item.mainCp == null || item.mainCp == '') &&
                item.multiProduct == 0 &&
                item.lpriceLadders.length == 0
              "
            >
              <!-- 小单位 -->
              <div class="product-add-reduce flex-h" v-if="item.showDw">
                <div @click="showModel(item, 1)">
                  <span class="item-list-price">{{
                    item.cxFileData &&
                    (item.cxFileData.djdw == 0 || item.cxFileData.djdw == 1)
                      ? item.cxFileData.dj
                      : getPrice(item, 1)
                  }}</span
                  ><span class="item-list-unit">/{{ item.dw }}</span>
                </div>
                <div class="step-list">
                  <div class="num-add-reduce flex-h">
                    <van-stepper
                      min="0"
                      theme="round"
                      button-size="30"
                      integer
                      @plus="plus(item, 1)"
                      async-change
                      @minus="minus(item, 1)"
                      @blur="plus(item, 1)"
                      v-model.number="item.sl"
                      :disabled="
                        (item.kcst < 1 && loginType == 0) ||
                        ((item.dj == '0.00' || item.dj == '0.0000') &&
                          item.cxfileCount == 0) ||
                        (item.zdqp > 0 && item.zdqp == item.hsgx1) ||
                        (item.zdqp > 0 && item.zdqp == item.hsgx)
                      "
                    />
                  </div>
                </div>
              </div>
              <!-- 中单位 -->
              <div
                class="product-add-reduce flex-h"
                v-if="item.showDw1 && item.dw1 !== ''"
              >
                <div @click="showModel(item, 2)">
                  <span class="item-list-price">{{
                    item.cxFileData && item.cxFileData.djdw == 3
                      ? item.cxFileData.dj
                      : getPrice(item, 2)
                  }}</span
                  ><span class="item-list-unit">/{{ item.dw1 }}</span>
                </div>
                <div class="step-list">
                  <div class="num-add-reduce flex-h">
                    <van-stepper
                      min="0"
                      theme="round"
                      button-size="30"
                      integer
                      @plus="plus(item, 2)"
                      @blur="plus(item, 2)"
                      async-change
                      @minus="minus(item, 2)"
                      v-model.number="item.sl1"
                      :disabled="
                        (item.kcst < 1 && loginType == 0) ||
                        ((item.dj == '0.00' || item.dj == '0.0000') &&
                          item.cxfileCount == 0)
                      "
                    />
                  </div>
                </div>
              </div>
              <!-- 大单位 -->
              <div class="product-add-reduce flex-h" v-if="item.showDw2">
                <div @click="showModel(item, 3)">
                  <span class="item-list-price">{{
                    item.cxFileData
                      ? getPrice(item, 3)
                      : item.mzprice && item.mzdjdw && item.mzdjdw == 2
                      ? item.mzprice
                      : getPrice(item, 3)
                  }}</span
                  ><span class="item-list-unit">/{{ item.dw2 }}</span>
                </div>
                <div class="step-list">
                  <div class="num-add-reduce flex-h">
                    <van-stepper
                      min="0"
                      theme="round"
                      button-size="30"
                      integer
                      @plus="plus(item, 3)"
                      @blur="plus(item, 3)"
                      async-change
                      @minus="minus(item, 3)"
                      v-model.number="item.sl2"
                      :disabled="
                        (item.kcst < 1 && loginType == 0) ||
                        ((item.dj == '0.00' || item.dj == '0.0000') &&
                          item.cxfileCount == 0)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 去详情页购买 -->
            <div
              class="item-click-detail"
              v-else
              @click="enterDetail(item, index)"
            >
              <div>
                <span class="item-list-price">{{ item.dj }}</span
                ><span class="item-list-unit"
                  >/{{
                    item.djdw === 3
                      ? item.dw1
                      : item.djdw === 2
                      ? item.dw2
                      : item.dw
                  }}</span
                >
              </div>
              <div
                class="item-rigrht-buy"
                :class="{ showOpacity: item.dj == '0.00' && item.mainCp == '' }"
                v-if="
                  (item.sl == 0 &&
                    item.sl1 == 0 &&
                    item.sl2 == 0 &&
                    item.mainCp == '') ||
                  (item.mainCp !== '' &&
                    item.mainSl == 0 &&
                    item.mainSl1 == 0 &&
                    item.mainSl2 == 0)
                "
              >
                展开购买
              </div>
              <div
                class="item-rigrht-buy flex-h"
                v-if="
                  (item.sl > 0 || item.sl1 > 0 || item.sl2 > 0) &&
                  item.mainCp == ''
                "
              >
                共
                <div
                  v-if="
                    item.dw2 && item.lpriceLadders.length == 0 && item.sl2 > 0
                  "
                >
                  <span class="popup-common-color">{{ item.sl2 }}</span
                  >{{ item.dw2 }}
                </div>
                <div
                  v-if="
                    item.dw1 && item.lpriceLadders.length == 0 && item.sl1 > 0
                  "
                >
                  <span class="popup-common-color">{{ item.sl1 }}</span
                  >{{ item.dw1 }}
                </div>
                <div v-if="item.dw && item.dw !== item.dw2 && item.sl > 0">
                  <span class="popup-common-color">{{ item.sl }}</span
                  >{{ item.dw }}
                </div>
              </div>
              <div
                class="item-rigrht-buy flex-h"
                :class="{ showOpacity: item.dj == '0.00' }"
                v-if="
                  item.mainCp !== '' &&
                  item.mainSl !== 0 &&
                  item.mainSl1 !== 0 &&
                  item.mainSl2 !== 0
                "
              >
                共
                <div
                  v-if="
                    item.dw2 &&
                    item.lpriceLadders.length == 0 &&
                    item.mainSl2 > 0
                  "
                >
                  <span class="popup-common-color">{{ item.mainSl2 }}</span
                  >{{ item.dw2 }}
                </div>
                <div
                  v-if="
                    item.dw1 &&
                    item.lpriceLadders.length == 0 &&
                    item.mainSl1 > 0
                  "
                >
                  <span class="popup-common-color">{{ item.mainSl1 }}</span
                  >{{ item.dw1 }}
                </div>
                <div v-if="item.dw && item.dw !== item.dw2 && item.mainSl > 0">
                  <span class="popup-common-color">{{ item.mainSl }}</span
                  >{{ item.dw }}
                </div>
              </div>
            </div>
          </div>
          <!-- 商品促销特价信息 -->
          <div
            class="list-item-tips"
            v-if="item.xsdj != 0 && loginType == 1 && !isTouris"
          >
            <span>价</span>
            <span
              >上次售价:{{ item.xsdj }}/{{
                item.xsdjdw == 3
                  ? item.dw1
                  : item.xsdjdw == 2
                  ? item.dw2
                  : item.dw
              }}</span
            >
          </div>
          <div class="list-item-tips" v-if="item.xssl > 0 && !isTouris">
            <span>历</span>
            <span>{{ item.xsrq }}购买{{ item.xssl }}{{ item.djdw }}</span>
          </div>
          <div class="list-item-tips" v-if="item.cpsm2 && !isTouris">
            <span>保</span>
            <span>有效期{{ item.cpsm2 }}</span>
          </div>
          <div class="list-item-tips" v-if="item.cxFileData && !isTouris">
            <span v-if="item.cxFileData.promotiontype == '赠送促销'">赠</span>
            <span v-else>特</span>
            <span>{{ item.cxFileData.giftexplain }}</span>
          </div>
        </div>
      </van-cell>
      <!-- <div class="flex-1"></div> -->
    </div>
    <!-- 一个一行 -->
    <div class="food-list-one" v-else-if="type == 1">
      <van-cell
        class="food-list-item"
        v-for="(item, index) in list"
        :key="index"
      >
        <!-- 套装 -->
        <div class="food-list-suit" v-if="item.composeStatus == 1">
          <div
            class="item-product-name line-clamp-1"
            @click="enterDetail(item.composeDataVO, index)"
          >
            {{ item.composeDataVO.title }}
          </div>
          <div class="item-product-base">
            <div class="item-product-common" v-if="item.composeDataVO">
              <img
                :src="item.composeDataVO.main.filename || localImg"
                alt=""
                @click="lookImg(item.composeDataVO.main.osslinks)"
                class="item-common-height"
              />
              <div>
                数量:{{ item.composeDataVO.main.sl }}/{{
                  item.composeDataVO.main.dwName
                }}
              </div>
            </div>
            <div
              class="item-product-common"
              v-if="
                item.composeDataVO.lGroups &&
                item.composeDataVO.lGroups.length > 0
              "
            >
              <div class="item-common-height item-product-symbol">+</div>
              <div class="flex-1"></div>
            </div>
            <div
              class="item-product-common"
              v-if="
                item.composeDataVO.lGroups &&
                item.composeDataVO.lGroups.length > 0
              "
            >
              <img
                :src="item.composeDataVO.lGroups[0].filename || localImg"
                alt=""
                @click="lookImg(item.composeDataVO.lGroups[0].osslinks)"
                class="item-common-height"
              />
              <div>
                数量:{{ item.composeDataVO.lGroups[0].sl }}/{{
                  item.composeDataVO.lGroups[0].dwName
                }}
              </div>
            </div>
            <div
              class="item-product-common"
              v-if="
                item.composeDataVO.lGroups &&
                item.composeDataVO.lGroups.length > 0
              "
            >
              <div class="item-common-height item-product-symbol">=</div>
              <div class="flex-1">更多</div>
            </div>
            <div class="item-product-common">
              <div class="item-common-height item-suit-price">
                <div style="color: #333">
                  可省<span style="color: #ef272c">{{
                    item.composeDataVO.discountPrice
                  }}</span
                  >元
                </div>
                <div>
                  <span style="color: #ef272c"
                    >¥{{ item.composeDataVO.dj }}</span
                  >/套
                </div>
              </div>
              <!-- 游客登陆 -->
              <div v-if="isTouris" class="item-product-hide">会员可见</div>
              <!-- 正常登陆 -->
              <div v-else>
                <div
                  class="flex-1 item-right-buy"
                  :class="{ showOpacity: item.composeDataVO.bzsj == '0.00' }"
                  @click="enterDetail(item.composeDataVO, index)"
                  v-if="
                    item.composeDataVO.sl === 0 &&
                    (!item.composeDataVO.numProduct ||
                      item.composeDataVO.numProduct[0].zsl == 0)
                  "
                >
                  展开购买
                </div>
                <div
                  class="flex-1 item-right-buy"
                  :class="{ showOpacity: item.composeDataVO.bzsj == '0.00' }"
                  @click="enterDetail(item.composeDataVO, index)"
                  v-else
                >
                  共{{ item.composeDataVO.sl }}套
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 临期 -->
        <div v-else-if="item.composeStatus == 2">
          <div class="list-item-base">
            <div class="item-base-left">
              <img
                :src="item.composeDataVO.main.filename || localImg"
                alt=""
                @click="lookImg(item.composeDataVO.main.osslinks)"
              />
              <div v-if="!isTouris" class="list-product-sign">
                省{{ item.composeDataVO.discountPrice }}元
              </div>
              <div class="list-product-triangle"></div>
              <div class="list-product-status">临</div>
            </div>
            <div class="item-base-right flex-1">
              <div class="item-product-name line-clamp-2">
                {{ item.composeDataVO.main.pm }}
              </div>
              <div class="item-code-follow">
                <div class="item-product-code">
                  {{ item.composeDataVO.main.bzgg }}
                </div>
                <div class="item-product-code">
                  {{ item.composeDataVO.main.tm }}
                </div>
              </div>
              <div class="item-code-follow">
                <div class="item-product-code">
                  条码:{{ item.composeDataVO.main.cpbh }}
                </div>
              </div>
              <div v-if="isTouris" class="item-product-hide">会员可见</div>
              <div
                class="product-add-reduce flex-h"
                style="height: 24px"
                v-else
              >
                <div style="font-size: 12px">
                  <span class="item-list-price"
                    >¥{{ item.composeDataVO.dj }}</span
                  >/{{ item.composeDataVO.main.dwName }}
                </div>
                <div
                  class="item-click-detail"
                  style="justify-content: flex-end"
                  @click="enterDetail(item.composeDataVO, index)"
                  v-if="item.composeDataVO.tmpSellOver == 0"
                >
                  <div
                    class="item-rigrht-buy"
                    :class="{ showOpacity: item.composeDataVO.dj == 0 }"
                    v-if="
                      item.composeDataVO.sl === 0 &&
                      (!item.composeDataVO.numProduct ||
                        item.composeDataVO.numProduct[0].zsl == 0)
                    "
                  >
                    展开购买
                  </div>
                  <div class="item-rigrht-buy" v-else>
                    共{{ item.composeDataVO.sl }}
                    <span v-if="item.composeStatus == 1">套</span>
                    <span v-if="item.composeStatus == 2">{{
                      item.composeDataVO.main.dwName
                    }}</span>
                  </div>
                </div>
                <div
                  class="item-click-detail"
                  style="justify-content: flex-end"
                  v-else
                >
                  <div class="item-rigrht-buy showOpacity">已售罄</div>
                </div>
              </div>
            </div>
          </div>
          <div class="list-item-tips" v-if="!isTouris">
            <span>特</span>
            <span
              >原价{{ item.composeDataVO.bzsj }},可省{{
                item.composeDataVO.discountPrice
              }}元</span
            >
          </div>
          <div
            class="list-item-tips"
            v-if="item.composeDataVO.main.sm && !isTouris"
          >
            <span>保</span>
            <span>保质期{{ getTime(item) }}</span>
          </div>
        </div>
        <div v-else>
          <div
            class="list-item-special"
            v-if="item.hot == 1 || item.news == 1"
          ></div>
          <div class="item-special-name" v-if="item.news == 1">新</div>
          <div class="item-special-name" v-if="item.hot == 1">爆</div>
          <!-- 商品基本信息 -->
          <div class="list-item-base">
            <div class="item-base-left">
              <img
                :src="item.filePath || localImg"
                alt=""
                @click="lookImg(item.osslinks)"
              />
              <div
                class="list-product-sign"
                v-if="!isTouris && item.cxFileData"
              >
                <span v-if="item.cxFileData.promotiontype == '赠送促销'"
                  >有赠品</span
                >
                <span v-else>省{{ getDiscount(item) }}元</span>
              </div>
              <div class="flex-h">
                <!-- <div class="item-has-product" v-if="item.kcst == 1">有货</div> -->
                <div class="item-no-product" v-if="item.kcst < 1">售罄</div>
                <div
                  class="item-suit-product"
                  @click="showSuit(item, index)"
                  v-if="loginType == 1"
                >
                  赠送
                </div>
                <!-- <div
                class="item-product-follow"
                v-if="item.gzcp == 0"
                @click="followProduct(item)"
              >
                关注
              </div>
              <div
                class="item-product-follow"
                v-else
                @click="followProduct(item)"
              >
                已关注
              </div> -->
              </div>
            </div>
            <div class="item-base-right flex-1">
              <div style="position: relative">
                <div
                  class="item-product-name line-clamp-2"
                  @click="enterDetail(item, index)"
                >
                  {{ item.pm }}
                </div>
                <div class="item-code-follow">
                  <div
                    class="item-product-code"
                    @click="enterDetail(item, index)"
                  >
                    条码:{{ item.tm }}
                  </div>
                </div>
                <div class="item-code-follow">
                  <div class="item-product-code" style="margin: 0 0 6px 0">
                    编号:{{ item.cpbh }}
                  </div>
                </div>
                <div class="item-product-base flex-h">
                  <div class="item-product-spec" v-if="item.bzq == 0">
                    包装:{{ item.bzgg }}
                  </div>
                  <div class="item-product-spec" v-else>
                    保质期:{{ item.bzq }}
                  </div>
                  <div class="item-product-batch" v-if="item.zdqp > 0">
                    起批:{{ item.zdqp }}{{ item.dw }}
                  </div>
                </div>
                <!-- 设置数量气泡框 -->
                <div class="number-Bubble-pop" v-show="item.showPop > 0">
                  <div class="tag">
                    <div @click.stop="item.showKey = true">
                      数量:{{
                        item.showPop == 1
                          ? item.sl
                          : item.showPop == 2
                          ? item.sl1
                          : item.sl2
                      }}{{
                        item.showPop == 1
                          ? item.dw
                          : item.showPop == 2
                          ? item.dw1
                          : item.dw2
                      }}
                    </div>
                    <div class="pop-shu">|</div>
                    <div @click.stop="popReduce(item)">
                      <van-icon name="minus" class="pop-minus" />
                    </div>
                  </div>

                  <van-number-keyboard
                    :title="'当前输入值:' + keyNum"
                    @input="onInput"
                    theme="custom"
                    close-button-text="完成"
                    :show="item.showKey"
                    @blur="onBlur(item)"
                    @delete="onDelete"
                  />
                </div>
                <!-- 设置价格气泡框 -->
                <div class="price-Bubble-pop" v-show="item.showPrice > 0">
                  <div class="tag">
                    {{ getPrice(item, item.showPrice) }}/{{
                      item.showPrice == 1
                        ? item.dw
                        : item.showPrice == 2
                        ? item.dw1
                        : item.dw2
                    }}
                  </div>
                  <van-number-keyboard
                    :title="'当前输入值:' + keyPrice"
                    @input="onInput1"
                    theme="custom"
                    extra-key="."
                    close-button-text="完成"
                    :show="item.priceKey"
                    @blur="onBlur1(item)"
                    @delete="onDelete1"
                  />
                </div>
              </div>
              <!-- 游客模式 -->
              <div class="item-product-hide" v-if="isTouris">会员可见</div>
              <!-- 正常登陆 -->
              <div v-else>
                <!-- 产品购买列表 -->
                <div
                  class="item-buy-unit"
                  v-if="
                    (item.mainCp == null || item.mainCp == '') &&
                    item.multiProduct == 0 &&
                    item.lpriceLadders.length == 0
                  "
                >
                  <!-- 小单位 -->
                  <div class="product-add-reduce flex-h" v-if="item.showDw">
                    <div class="dw-price-common" @click="showModel(item, 1)">
                      <span class="item-list-price">{{
                        item.cxFileData &&
                        (item.cxFileData.djdw == 0 || item.cxFileData.djdw == 1)
                          ? item.cxFileData.dj
                          : getPrice(item, 1)
                      }}</span
                      ><span class="item-list-unit">/{{ item.dw }}</span>
                    </div>
                    <div class="step-list">
                      <div class="num-add-reduce flex-h">
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          integer
                          @plus="plus(item, 1)"
                          disable-input
                          @minus="minus(item, 1)"
                          async-change
                          v-model.number="item.sl"
                          :show-minus="false"
                          :show-input="item.sl > 0 ? true : false"
                          :disabled="
                            (item.kcst < 1 && loginType == 0) ||
                            !item.showDw ||
                            item.dj == '0.00' ||
                            (item.zdqp > 0 && item.zdqp == item.hsgx1) ||
                            (item.zdqp > 0 && item.zdqp == item.hsgx)
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 中单位 -->
                  <div
                    class="product-add-reduce flex-h"
                    v-if="item.showDw1 && item.dw1 !== ''"
                  >
                    <div class="dw-price-common" @click="showModel(item, 2)">
                      <span class="item-list-price">{{
                        item.cxFileData && item.cxFileData.djdw == 3
                          ? item.cxFileData.dj
                          : getPrice(item, 2)
                      }}</span
                      ><span class="item-list-unit">/{{ item.dw1 }}</span>
                    </div>
                    <div class="step-list">
                      <div class="num-add-reduce flex-h">
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          disable-input
                          integer
                          @plus="plus(item, 2)"
                          async-change
                          @minus="minus(item, 2)"
                          :show-minus="false"
                          :show-input="item.sl1 > 0 ? true : false"
                          v-model.number="item.sl1"
                          :disabled="
                            (item.kcst < 1 && loginType == 0) ||
                            !item.showDw1 ||
                            (item.dj == '0.00' && !item.mzprice)
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 大单位 -->
                  <div class="product-add-reduce flex-h" v-if="item.showDw2">
                    <div class="dw-price-common" @click="showModel(item, 3)">
                      <span class="item-list-price">{{
                        item.cxFileData
                          ? getPrice(item, 3)
                          : item.mzprice && item.mzdjdw && item.mzdjdw == 2
                          ? item.mzprice
                          : getPrice(item, 3)
                      }}</span
                      ><span class="item-list-unit">/{{ item.dw2 }}</span>
                    </div>
                    <div class="step-list">
                      <div class="num-add-reduce flex-h">
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          disable-input
                          integer
                          @plus="plus(item, 3)"
                          async-change
                          @minus="minus(item, 3)"
                          :show-minus="false"
                          :show-input="item.sl2 > 0 ? true : false"
                          v-model.number="item.sl2"
                          :disabled="
                            (item.kcst < 1 && loginType == 0) ||
                            !item.showDw2 ||
                            (item.dj == '0.00' && !item.mzprice)
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- 代客下单赠送品信息 -->
                  <div
                    class="product-add-reduce flex-h"
                    v-if="
                      item.lSends &&
                      item.lSends.length > 0 &&
                      (item.lSends[0].sl > 0 ||
                        item.lSends[0].sl1 > 0 ||
                        item.lSends[0].sl2 > 0)
                    "
                  >
                    <div class="dw-price-common">
                      <span class="item-list-price">赠送</span
                      ><span class="item-list-unit"
                        >({{
                          item.lSends[0].sl > 0
                            ? item.dw
                            : item.lSends[0].sl1 > 0
                            ? item.dw1
                            : item.dw2
                        }}数)</span
                      >
                    </div>
                    <div class="step-list">
                      <div class="num-add-reduce flex-h">
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          disable-input
                          integer
                          v-model.number="item.lSends[0].sl2"
                          v-if="item.lSends[0].sl2 > 0"
                          :show-minus="false"
                          :show-plus="false"
                        />
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          disable-input
                          integer
                          v-model.number="item.lSends[0].sl1"
                          v-if="item.lSends[0].sl1 > 0"
                          :show-minus="false"
                          :show-plus="false"
                        />
                        <van-stepper
                          min="0"
                          theme="round"
                          button-size="26"
                          disable-input
                          integer
                          v-model.number="item.lSends[0].sl"
                          v-if="item.lSends[0].sl > 0"
                          :show-minus="false"
                          :show-plus="false"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 去详情页购买 -->
                <div
                  class="item-click-detail"
                  v-else
                  @click="enterDetail(item, index)"
                >
                  <div>
                    <span class="item-list-price">{{ item.dj }}</span
                    ><span class="item-list-unit"
                      >/{{
                        item.djdw === 3
                          ? item.dw1
                          : item.djdw === 2
                          ? item.dw2
                          : item.dw
                      }}</span
                    >
                  </div>
                  <div
                    class="item-rigrht-buy"
                    :class="{
                      showOpacity: item.dj == '0.00' && item.mainCp == '',
                    }"
                    v-if="
                      (item.sl == 0 &&
                        item.sl1 == 0 &&
                        item.sl2 == 0 &&
                        item.mainCp == '') ||
                      (item.mainCp !== '' &&
                        item.mainSl == 0 &&
                        item.mainSl1 == 0 &&
                        item.mainSl2 == 0)
                    "
                  >
                    展开购买
                  </div>
                  <div
                    class="item-rigrht-buy flex-h"
                    v-if="
                      (item.sl > 0 || item.sl1 > 0 || item.sl2 > 0) &&
                      item.mainCp == ''
                    "
                  >
                    共
                    <div
                      v-if="
                        item.dw2 &&
                        item.lpriceLadders.length == 0 &&
                        item.sl2 > 0
                      "
                    >
                      <span class="popup-common-color">{{ item.sl2 }}</span
                      >{{ item.dw2 }}
                    </div>
                    <div
                      v-if="
                        item.dw1 &&
                        item.lpriceLadders.length == 0 &&
                        item.sl1 > 0
                      "
                    >
                      <span class="popup-common-color">{{ item.sl1 }}</span
                      >{{ item.dw1 }}
                    </div>
                    <div v-if="item.dw && item.dw !== item.dw2 && item.sl > 0">
                      <span class="popup-common-color">{{ item.sl }}</span
                      >{{ item.dw }}
                    </div>
                  </div>
                  <div
                    class="item-rigrht-buy flex-h"
                    :class="{ showOpacity: item.dj == '0.00' }"
                    v-if="
                      item.mainCp !== '' &&
                      (item.mainSl !== 0 ||
                        item.mainSl1 !== 0 ||
                        item.mainSl2 !== 0)
                    "
                  >
                    共
                    <div
                      v-if="
                        item.dw2 &&
                        item.lpriceLadders.length == 0 &&
                        item.mainSl2 > 0
                      "
                    >
                      <span class="popup-common-color">{{ item.mainSl2 }}</span
                      >{{ item.dw2 }}
                    </div>
                    <div
                      v-if="
                        item.dw1 &&
                        item.lpriceLadders.length == 0 &&
                        item.mainSl1 > 0
                      "
                    >
                      <span class="popup-common-color">{{ item.mainSl1 }}</span
                      >{{ item.dw1 }}
                    </div>
                    <div
                      v-if="item.dw && item.dw !== item.dw2 && item.mainSl > 0"
                    >
                      <span class="popup-common-color">{{ item.mainSl }}</span
                      >{{ item.dw }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 商品促销特价信息 -->
          <div
            class="list-item-tips"
            v-if="item.xsdj != 0 && loginType == 1 && !isTouris"
          >
            <span>价</span>
            <span
              >上次售价:{{ item.xsdj }}/{{
                item.xsdjdw == 3
                  ? item.dw1
                  : item.xsdjdw == 2
                  ? item.dw2
                  : item.dw
              }}</span
            >
          </div>
          <div class="list-item-tips" v-if="item.xssl > 0 && !isTouris">
            <span>历</span>
            <span
              >{{ item.xsrq }}购买{{ item.xssl
              }}{{
                item.xsdjdw == 3
                  ? item.dw1
                  : item.xsdjdw == 2
                  ? item.dw2
                  : item.dw
              }}</span
            >
          </div>
          <div class="list-item-tips" v-if="item.cpsm2 != '' && !isTouris">
            <span>保</span>
            <span>{{ item.cpsm1 }}至{{ item.cpsm2 }}</span>
          </div>
          <div class="list-item-tips" v-if="item.cxFileData && !isTouris">
            <span v-if="item.cxFileData.promotiontype == '赠送促销'">赠</span>
            <span v-else>特</span>
            <span>{{ item.cxFileData.giftexplain }}</span>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- 套装 -->
    <div class="food-list-suit" v-else>
      <van-cell
        class="food-list-item"
        v-for="(item, index) in list"
        :key="index"
      >
        <div
          class="item-product-name line-clamp-1"
          @click="enterDetail(item, index)"
        >
          {{ item.title }}
        </div>
        <div class="item-product-base">
          <div class="item-product-common" v-if="item.main">
            <img
              :src="item.main.filename || localImg"
              alt=""
              @click="lookImg(item.main.osslinks)"
              class="item-common-height"
            />
            <div>数量:{{ item.main.sl }}{{ item.main.dwName }}</div>
          </div>
          <div class="item-product-common">
            <div class="item-common-height item-product-symbol">+</div>
            <div class="flex-1"></div>
          </div>
          <div class="item-product-common" v-if="item.lgroups">
            <img
              :src="item.lgroups[0].filename"
              alt=""
              @click="lookImg(item.lgroups[0].osslinks)"
              class="item-common-height"
            />
            <div>数量:{{ item.lgroups[0].sl }}{{ item.lgroups[0].dwName }}</div>
          </div>
          <div class="item-product-common">
            <div class="item-common-height item-product-symbol">=</div>
            <div class="flex-1">更多</div>
          </div>
          <div class="item-product-common">
            <div class="item-common-height item-suit-price">
              <div style="color: #333">
                可省<span style="color: #ef272c">{{ item.discountPrice }}</span
                >元
              </div>
              <div>
                <span style="color: #ef272c">¥{{ item.dj }}</span
                >/套
              </div>
            </div>
            <div
              class="flex-1 item-right-buy"
              :class="{ showOpacity: item.bzsj == '0.00' }"
              @click="enterDetail(item, index)"
              v-if="item.sl == 0"
            >
              展开购买
            </div>
            <div
              class="flex-1 item-right-buy"
              :class="{ showOpacity: item.bzsj == '0.00' }"
              @click="enterDetail(item, index)"
              v-else
            >
              共{{ item.sl }}套
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- 代客下单送赠品弹窗 -->
    <van-popup v-model="show" class="suit-pop" round closeable>
      <div class="pop-content">
        <van-field
          v-model="info.num"
          type="digit"
          label="赠送数量"
          placeholder="请输入赠送数量"
        />
        <van-radio-group v-model="info.buydw" direction="horizontal">
          <van-radio
            name="0"
            v-if="info.dw && info.hsgx !== 1"
            icon-size="24px"
            >{{ info.dw }}</van-radio
          >
          <van-radio name="3" v-if="info.dw1" icon-size="24px">{{
            info.dw1
          }}</van-radio>
          <van-radio name="2" v-if="info.dw2" icon-size="24px">{{
            info.dw2
          }}</van-radio>
        </van-radio-group>
        <div class="pop-btn" @click="addSuit">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { mapState } from "vuex";
export default {
  data() {
    return {
      num: 0,
      keyNum: "", //购买数量
      keyPrice: "", //购买金额
      show: false,
      curIndex: 0, //操作的索引值
      info: {}, //操作的产品数据
      show1: false, //赠品数字键盘
      localImg: require("../assets/no-img.png"),
    };
  },
  props: {
    type: {
      type: Number,
      default: 0, //0是两个排列，1是单个排列，2是套装
    },
    loginType: {
      type: Number,
      default: 0, //0是正常登陆1是代客下单
    },
    isTouris: {
      type: Boolean,
      default: false, //是否是游客登陆
    },
    list: {
      type: Array, //产品列表
    },
  },
  computed: {
    ...mapState(["priceDecimal"]),
  },
  methods: {
    // 计算特价优惠金额
    getDiscount(item) {
      let price;
      //促销大单位,djdw大单位
      if (item.cxFileData.djdw == 2 && item.djdw == 2) {
        price = parseFloat(item.dj - item.cxFileData.dj).toFixed(2);
      }
      //促销大单位djdw小单位
      else if (item.cxFileData.djdw == 2 && item.djdw < 2) {
        price = parseFloat(item.dj * item.hsgx - item.cxFileData.dj).toFixed(2);
      }
      //促销小单位djdw大单位
      else if (item.cxFileData.djdw < 2 && item.djdw == 2) {
        price = parseFloat(item.dj / item.hsgx - item.cxFileData.dj).toFixed(2);
      }
      //促销小单位djdw小单位
      else if (item.cxFileData.djdw < 2 && item.djdw < 2) {
        price = parseFloat(item.dj - item.cxFileData.dj).toFixed(2);
      }
      return price;
    },
    //代客下单显示赠送弹窗
    showSuit(item, index) {
      this.curIndex = index;
      this.info = {
        dw: item.dw,
        dw1: item.dw1,
        dw2: item.dw2,
        buydw: "1",
        num: "", //输入的赠送数量
        cpuni: item.uni,
        hsgx1: item.hsgx1,
        hsgx: item.hsgx,
        uni: "",
      };
      if (item.lSends && item.lSends.length > 0) {
        this.info.uni = item.lSends[0].uni;
        this.info.num =
          item.lSends[0].sl > 0
            ? item.lSends[0].sl
            : item.lSends[0].sl1 > 0
            ? item.lSends[0].sl1
            : item.lSends[0].sl2;
        this.info.buydw =
          item.lSends[0].sl > 0 ? "0" : item.lSends[0].sl1 > 0 ? "3" : "2";
      }
      this.show = true;
    },
    //代客下单赠送弹窗提交
    addSuit() {
      let { curIndex, info } = this.$data;
      if ((!info.num || info.num == 0) && info.uni == "") {
        this.$toast("赠送数量不能为空");
        return;
      }
      if (info.buydw == 1) {
        this.$toast("请选择赠送单位");
        return;
      }
      this.show = false;
      this.$emit("addSuit", curIndex, info);
    },
    getTime(item) {
      if (
        item.composeDataVO.main.sm &&
        item.composeDataVO.main.sm.length > 10
      ) {
        return item.composeDataVO.main.sm.substring(0, 10);
      }
      return item.composeDataVO.main.sm;
    },
    //显示数字键盘
    showModel(item, type) {
      if (
        sessionStorage.getItem("loginType") == 0 ||
        sessionStorage.getItem("loginType") == null
      )
        return;
      if (
        item.dj == 0 ||
        item.dj == "0.00" ||
        (item.kcst < 1 && this.loginType == 0) ||
        item.cxFileData
      )
        return;
      item.showPop = 0;
      item.showKey = false;
      item.showPrice = type;
      item.priceKey = true;
    },
    //处理不同单位下的价格
    getPrice(item, type) {
      var num = this.priceDecimal || 2;
      if (item.cxFileData) {
        if (type == 1) {
          if (item.cxFileData.djdw < 2) {
            return parseFloat(item.cxFileData.dj).toFixed(num);
          }
          if (item.cxFileData.djdw == 3) {
            return parseFloat(item.cxFileData.dj / item.hsgx1).toFixed(num);
          }
          if (item.cxFileData.djdw == 2) {
            return parseFloat(item.cxFileData.dj / item.hsgx).toFixed(num);
          }
        }
        // 中单位
        else if (type == 2) {
          if (item.cxFileData.djdw < 2) {
            return parseFloat(item.cxFileData.dj * item.hsgx1).toFixed(num);
          }
          if (item.cxFileData.djdw == 3) {
            return parseFloat(item.cxFileData.dj).toFixed(num);
          }
          if (item.cxFileData.djdw == 2) {
            return parseFloat(
              (item.cxFileData.dj / item.hsgx) * item.hsgx1
            ).toFixed(num);
          }
        } else {
          if (item.cxFileData.djdw < 2) {
            console.log(123);
            return parseFloat(item.cxFileData.dj * item.hsgx).toFixed(num);
          }
          if (item.cxFileData.djdw == 3) {
            return parseFloat(
              (item.cxFileData.dj * item.hsgx) / item.hsgx1
            ).toFixed(num);
          }
          if (item.cxFileData.djdw == 2) {
            return parseFloat(item.cxFileData.dj).toFixed(num);
          }
        }
      } else {
        if (type == 1) {
          if (item.djdw < 2) {
            return parseFloat(item.dj).toFixed(num);
          }
          if (item.djdw == 3) {
            return parseFloat(item.dj / item.hsgx1).toFixed(num);
          }
          if (item.djdw == 2) {
            return parseFloat(item.dj / item.hsgx).toFixed(num);
          }
        }
        // 中单位
        else if (type == 2) {
          if (item.djdw < 2) {
            return parseFloat(item.dj * item.hsgx1).toFixed(num);
          }
          if (item.djdw == 3) {
            return parseFloat(item.dj).toFixed(num);
          }
          if (item.djdw == 2) {
            return parseFloat((item.dj / item.hsgx) * item.hsgx1).toFixed(num);
          }
        }
        // 大单位
        else if (type == 3) {
          if (item.djdw < 2) {
            if ((item.mzdjdw == 0 || item.mzdjdw == 1) && item.mzprice) {
              return parseFloat(item.mzprice * item.hsgx).toFixed(num);
            }
            return parseFloat(item.dj * item.hsgx).toFixed(num);
          }
          if (item.djdw == 3) {
            return parseFloat((item.dj * item.hsgx) / item.hsgx1).toFixed(num);
          }
          if (item.djdw == 2) {
            return parseFloat(item.dj).toFixed(num);
          }
        }
      }
      // 小单位
      if (type == 1) {
        if (item.djdw < 2) {
          if (
            item.cxFileData &&
            (item.cxFileData.djdw == 0 || item.cxFileData.djdw == 1)
          ) {
            item.dj = item.cxFileData.dj;
          }
          return parseFloat(item.dj).toFixed(num);
        }
        if (item.djdw == 3) {
          if (item.cxFileData && item.cxFileData.djdw == 3) {
            item.dj = item.cxFileData.dj;
          }
          return parseFloat(item.dj / item.hsgx1).toFixed(num);
        }
        if (item.djdw == 2) {
          if (item.cxFileData && item.cxFileData.djdw == 2) {
            item.dj = item.cxFileData.dj;
          }
          return parseFloat(item.dj / item.hsgx).toFixed(num);
        }
      }
      // 中单位
      else if (type == 2) {
        if (item.djdw < 2) {
          if (
            item.cxFileData &&
            (item.cxFileData.djdw == 0 || item.cxFileData.djdw == 1)
          ) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          return parseFloat(item.dj * item.hsgx1).toFixed(num);
        }
        if (item.djdw == 3) {
          if (item.cxFileData && item.cxFileData.djdw == 3) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          return parseFloat(item.dj).toFixed(num);
        }
        if (item.djdw == 2) {
          if (item.cxFileData && item.cxFileData.djdw == 2) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          return parseFloat((item.dj / item.hsgx) * item.hsgx1).toFixed(num);
        }
      }
      // 大单位
      else if (type == 3) {
        if (item.djdw == 0 || item.djdw == 1) {
          if (
            item.cxFileData &&
            (item.cxFileData.djdw == 0 || item.cxFileData.djdw == 1)
          ) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          if ((item.mzdjdw == 0 || item.mzdjdw == 1) && item.mzprice) {
            return parseFloat(item.mzprice * item.hsgx).toFixed(num);
          }
          return parseFloat(item.dj * item.hsgx).toFixed(num);
        }
        if (item.djdw == 3) {
          if (item.cxFileData && item.cxFileData.djdw == 3) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          return parseFloat((item.dj * item.hsgx) / item.hsgx1).toFixed(num);
        }
        if (item.djdw == 2) {
          if (item.cxFileData && item.cxFileData.djdw == 2) {
            item.dj = parseFloat(item.cxFileData.dj).toFixed(num);
          }
          return parseFloat(item.dj).toFixed(num);
        }
      }
    },
    //收藏
    followProduct(item) {
      this.$emit("followProduct", item);
    },
    //进入详情页
    enterDetail(item, index) {
      if (this.isTouris) {
        this.$dialog
          .confirm({
            title: "您还未登陆",
            message: "游客模式无法查看价格和详情,是否去登陆？",
          })
          .then(() => {
            this.$router.push({
              path: "/login",
            });
          })
          .catch(() => {});
        return;
      }
      if (item.dj == "0.00" && !item.mzprice && item.mainCp == "") return;
      if (item.lGroups) {
        item.lgroups = item.lGroups;
      }
      this.$store.commit("setProductInfo", item);
      this.$emit("enterDetail", index);
    },
    //图片查看
    lookImg(images) {
      if (typeof images == "string") {
        images = images.split(",");
      }
      if (images) {
        ImagePreview({
          images: images,
          closeable: true,
          startPosition: 0,
        });
      } else {
        this.$toast("暂无产品图");
      }
    },
    //添加数量
    plus(item, type) {
      var zdqpFb = this.$store.state.zdqpFb;
      //判断是否有最低起批
      if (type == 1 && item.zdqp > 0 && item.sl < item.zdqp) {
        item.sl = item.zdqp;
      }
      //处理最低起批翻倍
      if (zdqpFb == 1 && item.zdqp > 0 && item.sl > item.zdqp) {
        var num = Math.ceil(item.sl / item.zdqp);
        item.sl = item.zdqp * num;
      }
      this.$emit("plus", item, type);
    },
    //领取优惠券
    takeConpou(item) {
      this.$emit("takeConpou", item);
    },
    //减少数量
    minus(item, type) {
      var zdqpFb = this.$store.state.zdqpFb;
      //判断是否有最低起批
      if (type == 1 && item.zdqp > 0 && item.sl < item.zdqp) {
        item.sl = 0;
      }
      //处理最低起批翻倍
      if (zdqpFb == 1 && item.zdqp > 0 && item.sl > item.zdqp) {
        var num = Math.floor(item.sl / item.zdqp);
        item.sl = item.zdqp * num;
      }
      this.$emit("plus", item, type);
    },
    //数量减少
    popReduce(item) {
      if (item.showPop == 1) {
        if (item.sl == 0) return;
        var zdqpFb = this.$store.state.zdqpFb;
        //判断是否有最低起批
        if (item.showPop == 1 && item.zdqp > 0 && item.sl <= item.zdqp) {
          item.sl = 0;
        }
        //处理最低起批翻倍
        else if (
          item.showPop == 1 &&
          zdqpFb == 1 &&
          item.zdqp > 0 &&
          item.sl > item.zdqp
        ) {
          item.sl--;
          var num = Math.floor(item.sl / item.zdqp);
          item.sl = item.zdqp * num;
        } else {
          item.sl--;
        }
      }
      if (item.showPop == 2) {
        if (item.sl1 == 0) return;
        item.sl1--;
      }
      if (item.showPop == 3) {
        if (item.sl2 == 0) return;
        item.sl2--;
      }
      this.$emit("plus", item, item.showPop);
    },
    onBlur(item) {
      item.showKey = false;
      this.$emit("onBlur", item, this.keyNum);
      this.$nextTick(() => {
        this.keyNum = "";
      });
    },
    onInput(name) {
      this.keyNum = this.keyNum.concat(name);
    },
    onDelete() {
      if (this.keyNum !== "") {
        this.keyNum = this.keyNum.slice(0, this.keyNum.length - 1);
      }
    },
    onBlur1(item) {
      item.priceKey = false;
      this.$emit("onBlur1", item, this.keyPrice);
      this.$nextTick(() => {
        this.keyPrice = "";
      });
    },
    onInput1(name) {
      this.keyPrice = this.keyPrice.concat(name);
    },
    onDelete1() {
      if (this.keyPrice !== "") {
        this.keyPrice = this.keyPrice.slice(0, this.keyPrice.length - 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-food {
  .showOpacity {
    opacity: 0.5 !important;
  }
  .suit-pop {
    width: 80%;
    padding: 20px;
    margin: auto;
    .van-radio-group--horizontal {
      margin: 10px 16px;
    }
    .van-field {
      font-size: 16px;
      >>> .van-cell__title {
        color: #000;
      }
    }
    .pop-btn {
      margin: 30px auto 0 auto;
      width: 70px;
      border-radius: 5px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background-color: #1989fa;
    }
  }
  // 套装
  .food-list-suit {
    >>> .van-cell {
      line-height: 1;
    }
    .food-list-item {
      border-bottom: 1px solid #eee;
      padding: 10px 4px;
      .item-product-name {
        font-size: 14px;
        color: #000;
        margin-bottom: 8px;
      }
      .item-product-base {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item-product-batch {
          font-size: 12px;
        }
        .item-product-common {
          color: #999;
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          height: 100px;
          .item-product-symbol {
            font-size: 20px;
            padding: 0 5px;
            line-height: 70px;
          }
          img {
            height: 70px;
            width: 70px;
            min-width: 70px;
          }
          .item-common-height {
            height: 70px;
          }
          .item-suit-price {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            :nth-child(2) {
              font-size: 13px;
              margin-top: 5px;
            }
          }
          .flex-1 {
            display: flex;
            align-items: flex-end;
          }
          .item-right-buy {
            justify-content: center;
            border: 1px solid #f4464a;
            align-items: center;
            justify-content: center;
            width: 60px;
            color: #f4464a;
            font-size: 13px;
            border-radius: 5px;
            float: right;
          }
          .showOpacity {
            opacity: 0.5 !important;
          }
        }
      }
    }
  }
  //双
  .food-list-tow {
    display: flex;
    flex-wrap: wrap;
    >>> .van-cell {
      line-height: 1;
    }
    .food-list-item {
      margin: 10px 10px 0 0;
      width: 252.5px;
      padding: 10px 5px;
      border-radius: 5px;
      position: relative;
      .list-item-special {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        border-top: 30px solid red;
        border-right: 30px solid transparent;
      }
      .item-base-left {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        .show-over-time {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          font-size: 12px;
          height: 30px;
          line-height: 30px;
          padding: 0 5px;
          text-align: left;
          font-weight: 600;
        }
        .list-product-triangle {
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          border-top: 30px solid #ef272c;
          border-right: 30px solid transparent;
          z-index: 1;
        }
        .list-product-sign {
          position: absolute;
          left: 0;
          bottom: 30px;
          z-index: 2;
          min-width: 80px;
          height: 32px;
          background-color: rgba(238, 10, 36, 0.8);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .list-product-status {
          position: absolute;
          left: 3px;
          top: 3px;
          color: #fff;
          font-size: 12px;
          z-index: 2;
        }
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          object-fit: scale-down;
          position: absolute;
          right: 0;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .item-has-product {
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 5px;
          width: 36px;
          border: 1px solid #00bf94;
          color: #00bf94;
          font-size: 13px;
          text-align: center;
          z-index: 2;
        }
        .list-product-sign {
          position: absolute;
          left: 0;
          bottom: 30px;
          z-index: 2;
          min-width: 80px;
          padding: 0 6px;
          height: 32px;
          background-color: rgba(238, 10, 36, 0.8);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top-right-radius: 15px;
          border-bottom-right-radius: 15px;
          font-weight: bold;
        }
        .item-no-product {
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 3px;
          padding: 4px 8px;
          background-color: #9e9e9e;
          color: #fff;
          font-size: 14px;
          z-index: 2;
        }
        .item-no-coupon {
          position: absolute;
          top: 0;
          right: 0;
          height: 26px;
          line-height: 26px;
          width: 50px;
          text-align: center;
          font-size: 14px;
          color: #ff531b;
          border: 1px solid #ff531b;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          z-index: 2;
        }
        .item-has-coupon {
          position: absolute;
          top: 0;
          right: 0;
          height: 26px;
          line-height: 26px;
          width: 50px;
          text-align: center;
          font-size: 14px;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          color: #fff;
          background-color: #ff531b;
          z-index: 2;
        }
      }
      .item-product-name {
        margin-top: 4px;
        font-size: 18px;
        height: 36px;
        color: #000;
        cursor: pointer;
      }
      .item-specfollow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .number-Bubble-pop {
          position: absolute;
          bottom: 0;
          right: 0;
          .tag {
            padding: 0 6px;
            height: 34px;
            border: 2px solid #f46172;
            position: relative;
            background-color: #f46172;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            .pop-shu {
              margin: 0 10px;
              color: #fff;
            }
            .pop-minus {
              height: 24px;
              width: 24px;
              border: 1px solid #fff;
              border-radius: 50%;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              bottom: -40px;
              right: 14px;
              border-style: solid dashed dashed;
              border-color: #f46172 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              bottom: -40px;
              border-color: #f46172 transparent transparent;
            }
          }
        }
        .price-Bubble-pop {
          position: absolute;
          top: -30px;
          left: 0;
          .tag {
            width: 74px;
            height: 30px;
            border: 2px solid #f46172;
            position: relative;
            background-color: #f46172;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              bottom: -37px;
              left: 22px;
              border-style: solid dashed dashed;
              border-color: #f46172 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              bottom: -37px;
              border-color: #f46172 transparent transparent;
            }
          }
        }
        .item-product-spec {
          margin-top: 6px;
          color: #999;
          font-size: 12px;
        }
        .item-product-follow {
          border: 1px solid #ff531b;
          width: 44px;
          text-align: center;
          border-radius: 5px;
          color: #ff531b;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
        }
      }

      .product-add-reduce {
        justify-content: space-between;
        margin-top: 10px;
        .item-list-price {
          color: #f4464a;
          font-size: 20px;
          font-weight: bold;
        }
        .item-list-unit {
          font-size: 13px;
        }
        .num-add-reduce {
          justify-content: flex-end;
          >>> .van-stepper {
            // border-radius: 12px;
            // border: 1px solid #ee0a24;
            // border-right: none;
            // .van-stepper__minus {
            //   display: none;
            // }
            .van-stepper__plus {
              border: 1px solid #ee0a24;
              background: #fff;
              color: #ee0a24;
            }
          }
          >>> .van-stepper__input {
            width: 40px;
          }
        }
      }
      .item-product-hide {
        color: #999;
        text-align: right;
      }
      .item-click-detail {
        margin-top: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item-list-price {
          color: #f4464a;
          font-size: 18px;
          font-weight: bold;
        }
        .item-list-unit {
          font-size: 13px;
        }
        .item-rigrht-buy {
          border: 1px solid #f4464a;
          height: 24px;
          line-height: 24px;
          text-align: center;
          min-width: 70px;
          color: #f4464a;
          font-size: 14px;
          border-radius: 5px;
          justify-content: center;
          cursor: pointer;
        }
      }

      .list-item-tips {
        margin-top: 5px;
        >>> :nth-child(1) {
          background-color: #fe6c60;
          color: #fff;
          border-radius: 50%;
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
        }
        :nth-child(2) {
          color: #333;
          font-size: 15px;
        }
      }
    }
  }
  //单
  .food-list-one {
    >>> .van-cell {
      line-height: 1;
    }
    .food-list-item {
      border-bottom: 1px solid #eee;
      padding: 12px 10px 12px 2px;
      position: relative;
      // 套装
      .food-list-suit {
        .item-product-name {
          font-size: 14px;
          color: #000;
          margin-bottom: 8px;
          cursor: pointer;
        }
        .item-product-base {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-product-batch {
            font-size: 12px;
          }
          .item-product-common {
            color: #999;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            height: 100px;
            .item-product-symbol {
              font-size: 20px;
              padding: 0 5px;
              line-height: 70px;
            }
            img {
              height: 70px;
              width: 70px;
              min-width: 70px;
            }
            .item-common-height {
              height: 70px;
            }
            .item-suit-price {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              :nth-child(2) {
                font-size: 13px;
                margin-top: 5px;
              }
            }
            .flex-1 {
              display: flex;
              align-items: flex-end;
            }
            .item-right-buy {
              justify-content: center;
              border: 1px solid #f4464a;
              align-items: center;
              justify-content: center;
              width: 60px;
              color: #f4464a;
              font-size: 13px;
              border-radius: 5px;
              float: right;
              height: 24px;
            }
            .showOpacity {
              opacity: 0.5 !important;
            }
          }
        }
      }
      .list-item-special {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 0;
        border-top: 30px solid red;
        border-right: 30px solid transparent;
        z-index: 3;
      }
      .item-special-name {
        position: absolute;
        z-index: 4;
        color: #fff;
        font-size: 13px;
        top: 3px;
        left: 3px;
        transform: rotate(-45deg);
      }
      .list-item-base {
        display: flex;
        min-height: 136px;
      }
      .item-base-left {
        position: relative;
        width: 110px;
        height: 110px;
        min-width: 110px;
        border: 1px solid #eee;
        box-sizing: border-box;
        // border-radius: 5px;
        .list-product-sign {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 2;
          min-width: 100px;
          max-width: 110px;
          height: 28px;
          background-color: rgba(238, 10, 36, 0.8);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .list-product-triangle {
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          border-top: 30px solid #ef272c;
          border-right: 30px solid transparent;
          z-index: 1;
        }
        .list-product-status {
          position: absolute;
          left: 3px;
          top: 3px;
          color: #fff;
          font-size: 12px;
          z-index: 2;
        }
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          object-fit: scale-down;
          position: absolute;
          right: 0;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          //  border-radius: 5px;
        }
        .item-has-product {
          border-radius: 5px;
          width: 30px;
          border: 1px solid #00bf94;
          color: #00bf94;
          font-size: 12px;
          text-align: center;
          height: 16px;
          line-height: 16px;
          // z-index: 2;
          margin-top: 112px;
        }
        .item-no-product {
          border-radius: 5px;
          width: 30px;
          border: 1px solid #f4464a;
          color: #f4464a;
          text-align: center;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          // z-index: 2;
          margin-top: 112px;
        }
        .item-suit-product {
          border-radius: 5px;
          width: 36px;
          border: 1px solid #f4464a;
          color: #f4464a;
          text-align: center;
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          // z-index: 2;
          margin-left: 8px;
          margin-top: 112px;
        }
        .item-product-follow {
          border: 1px solid #ff531b;
          width: 44px;
          font-size: 12px;
          text-align: center;
          border-radius: 5px;
          color: #ff531b;
          height: 16px;
          line-height: 16px;
        }
      }
      .item-base-right {
        margin-left: 6px;
        .item-product-name {
          font-size: 16px;
          color: #000;
          height: 32px;
          cursor: pointer;
        }
        .item-product-base {
          align-items: center;
          justify-content: space-between;
          color: #999;
          font-size: 12px;
          .item-product-batch {
            font-size: 12px;
          }
        }
        .price-Bubble-pop {
          position: absolute;
          top: 40px;
          left: 0;
          .tag {
            width: 74px;
            height: 30px;
            border: 2px solid #f46172;
            position: relative;
            background-color: #f46172;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              bottom: -37px;
              left: 22px;
              border-style: solid dashed dashed;
              border-color: #f46172 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              bottom: -37px;
              border-color: #f46172 transparent transparent;
            }
          }
        }
        .number-Bubble-pop {
          position: absolute;
          bottom: 20px;
          right: 0;
          .tag {
            padding: 0 10px;
            height: 34px;
            border: 2px solid #f46172;
            position: relative;
            background-color: #f46172;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            .pop-shu {
              margin: 0 10px;
              color: #fff;
            }
            .pop-minus {
              height: 24px;
              width: 24px;
              border: 1px solid #fff;
              border-radius: 50%;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              bottom: -40px;
              right: 20px;
              border-style: solid dashed dashed;
              border-color: #f46172 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              bottom: -40px;
              border-color: #f46172 transparent transparent;
            }
          }
        }
        .item-code-follow {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-product-code {
            color: #999;
            font-size: 12px;
            margin: 6px 0;
          }
        }
        .item-click-detail {
          margin-top: 6px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-list-price {
            color: #f4464a;
            font-size: 13px;
          }
          .item-list-unit {
            font-size: 13px;
          }
          .item-rigrht-buy {
            border: 1px solid #f4464a;
            height: 24px;
            line-height: 24px;
            text-align: center;
            min-width: 60px;
            color: #f4464a;
            font-size: 13px;
            border-radius: 5px;
            justify-content: center;
          }
        }
        .product-add-reduce {
          justify-content: space-between;
          // justify-content: flex-end;
          margin-top: 10px;
          .dw-price-common {
            width: 75px;
            text-align: right;
          }
          .item-list-price {
            color: #f4464a;
            font-size: 13px;
          }
          .item-list-unit {
            font-size: 13px;
          }
          .num-add-reduce {
            justify-content: flex-end;
            >>> .van-stepper {
              // border-radius: 12px;
              // border: 1px solid #ee0a24;
              // border-right: none;
              .van-stepper__plus {
                border: 1px solid #ee0a24;
                background: #fff;
                color: #ee0a24;
              }
              // .van-stepper__minus {
              //   display: none;
              // }
            }
          }
        }

        .item-product-hide {
          color: #999;
          text-align: right;
        }
      }
      .list-item-tips {
        margin-top: 5px;
        >>> :nth-child(1) {
          background-color: #fe6c60;
          color: #fff;
          border-radius: 50%;
          display: inline-block;
          width: 18px;
          height: 18px;
          line-height: 18px;
          font-size: 12px;
          text-align: center;
        }
        :nth-child(2) {
          color: #fe7b6b;
          font-size: 12px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/food-list.vue